/**============================================================
*   [form] formCheckbox
*   description : フォームのチェックボックス処理（WP用）
============================================================*/
document.addEventListener('DOMContentLoaded', () => {
  const myForm = document.getElementsByClassName('mw_wp_form');

  if (myForm.length > 0) {
    Array.from(myForm).forEach((form) => {
      if (form.classList.contains('mw_wp_form_input')) {
        const error = form.getElementsByClassName('error');
        const ref = document.referrer;
        if (error.length === 0 && ref.indexOf('/confirm/') === -1) {
          const checkbox = document.getElementById('magazine-1');
          if (checkbox) {
            checkbox.checked = true;
          }
        }
      }
    });
  }
});
